module.exports = __webpack_public_path__ + "static/img/4.acbf701.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store/4.png
// module id = K+rO
// module chunks = 0